<template>
  <v-row class="wz_toolbar" no-gutters>
    <v-col cols="3">
      <v-menu bottom left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn dark icon v-bind="attrs" v-on="on">
            <v-icon>mdi-menu</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item v-for="(item, i) in menuItems" :key="i" :to="item.path">
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-col>

    <v-col justify="end" align="end" cols="9">
      <v-btn color="white" right icon @click="AUTH_LOGOUT()">
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>
<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      menuItems: [
        { title: "Reporting", icon: "mdi-view-dashboard", path: "/home" },
        { title: "Strategy Reporting", icon: "mdi-chart-bar", path: "/reporting2" },
        { title: "Manage Clients", icon: "mdi-forum", path: "/clients" },
        { title: "User roles", icon: "mdi-account-settings", path: "/roles"}
      ],
    };
  },
  methods: {
    ...mapActions("authStore", ["AUTH_LOGOUT"]),
  },
};
</script>
<style>
.wz_toolbar {
  background-color: var(--v-secondary-base);
  position: fixed;
  width: 100%;
  z-index: 100;
}
</style>
